import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ListingCard } from "@/components/Listings";
import { useAuth } from "@/contexts/AuthContext";
import { useFavorites } from "@/hooks/useFavorites";

export default function Search() {
  const [searchParams] = useSearchParams();
  const q = searchParams.get("q") || "";
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const { favs, toggle } = useFavorites(user);

  useEffect(() => {
    api.get("/listings", { params: { q, limit: 60 } }).then(({ data }) => setItems(data.items));
  }, [q]);

  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-8 mt-8" data-testid="search-page">
      <div className="font-mono-data text-xs uppercase mb-2">
        <Link to="/" className="link-blue">home</Link> / search
      </div>
      <h1 className="font-display text-3xl md:text-5xl uppercase border-b-2 border-black pb-2">/ Results for "{q}"</h1>
      <div className="font-mono-data text-xs uppercase text-gray-600 mt-2">{items.length} listings found</div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        {items.map((l) => <ListingCard key={l.listing_id} listing={l} isFavorite={favs.includes(l.listing_id)} onToggleFavorite={toggle} />)}
      </div>
      {items.length === 0 && <div className="border-2 border-black p-12 text-center font-mono-data text-sm uppercase text-gray-500 mt-6">No results.</div>}
    </div>
  );
}
